module.exports = __webpack_public_path__ + "img/홍대 카페.108bfe3d.png";